import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { faInfoCircle, faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { BlockModel } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-delete-question-dialog',
  templateUrl: 'delete-question-dialog.component.html',
  styleUrl: './delete-question-dialog.component.scss'
})
export class DeleteQuestionDialogComponent implements OnInit {
  faExclamationCircle = faExclamationCircle;
  faInfoCircle = faInfoCircle;

  constructor(
    private dialogRef: MatDialogRef<DeleteQuestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { questionsCount: number; affectedQuestions: Set<Question>; affectedBlocks: Set<BlockModel> }
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-confirm__dialog');
    this.dialogRef.disableClose = true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
